import { runDemo } from "../shared/demoRunner";
import { createGuiScene } from "./scene";

runDemo({ createScene: createGuiScene });
